import { render, staticRenderFns } from "./doorGoodsEdit.vue?vue&type=template&id=25b2c17c&scoped=true"
import script from "./doorGoodsEdit.vue?vue&type=script&lang=js"
export * from "./doorGoodsEdit.vue?vue&type=script&lang=js"
import style0 from "./doorGoodsEdit.vue?vue&type=style&index=0&id=25b2c17c&prod&lang=css"
import style1 from "./doorGoodsEdit.vue?vue&type=style&index=1&id=25b2c17c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b2c17c",
  null
  
)

export default component.exports